import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import TrustBar from '../components/TrustBar';
import CertificationBadges from '../components/CertificationBadges';
import LifeStageSelector from '../components/LifeStageSelector';
import WhyInsurance from '../components/WhyInsurance';
import Services from '../components/Services';
import ProcessTimeline from '../components/ProcessTimeline';
import AdvisorSection from '../components/AdvisorSection';
import FinancialQuotes from '../components/FinancialQuotes';
import Testimonials from '../components/Testimonials';
import Calculators from '../components/Calculators';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';
import StickyButtons from '../components/StickyButtons';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <Hero />
        <TrustBar />
        <CertificationBadges />
        <LifeStageSelector />
        <WhyInsurance />
        <Services />
        <ProcessTimeline />
        <AdvisorSection />
        <FinancialQuotes />
        <Testimonials />
        <Calculators />
        <CTASection />
      </main>
      <Footer />
      <StickyButtons />
    </div>
  );
}
